import { Stack } from "@mui/material";

import { PayInfoLabelDeprecated } from "../../Pay/PayInfoLabelDeprecated";
import { ShiftQualificationPill } from "../QualificationPill";

interface WorkerShiftCardFooterProps {
  hourlyPay?: string;
  totalPay?: string;
  totalWithBoostPay?: string;
  qualificationText: string;
  isLoadingQualification?: boolean;
}

/**
 * Renders qualification pill and pay info label
 */
export function WorkerShiftCardFooter(props: WorkerShiftCardFooterProps) {
  const {
    hourlyPay,
    totalPay,
    totalWithBoostPay,
    qualificationText: qualificationName,
    isLoadingQualification,
  } = props;

  return (
    <Stack direction="row" justifyContent="space-between" spacing={3}>
      <ShiftQualificationPill
        qualificationText={qualificationName}
        isLoading={isLoadingQualification}
      />

      <PayInfoLabelDeprecated
        isLoading={false}
        hourlyPay={hourlyPay}
        totalPay={totalPay}
        totalWithBoostPay={totalWithBoostPay}
      />
    </Stack>
  );
}
